export default __webpack_public_path__ + "static/media/paypal-logo-2.e414836f.png";